import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/core/common/redux/RemoteRecord';
import { getVerifyKanbanItems } from 'b2b-apps/core/kanban';
import { VerifyKanbanItemsType } from 'b2b-common/core/kanban/Kanban.types';

export const useVerifyKanbanItemsData = (): RemoteRecord<VerifyKanbanItemsType> => useSelector(getVerifyKanbanItems);
